import {Component, OnInit} from '@angular/core';
import {PopButtonComponent} from '@library/shared/buttons/pop-button.component';
import {IMenuItem} from '@nxt/model-core';
import {LocalStorageService} from '@library/shared/_services/local-storage.service';
import {MessagingService} from '@library/nxt/_services/messaging.service';
import {ClientService} from "@library/shared/_services/client.service";

@Component({
    selector: 'messaging-view-toggle',
    standalone: true,
    imports: [
        PopButtonComponent
    ],
    template:`
        <pop-button iconName="heroicon-arrows-right-left"
                    iconClass="ml-2 h-4 w-4 text-gray-500"
                    [items]="viewsMenu"
                    btnClass="border-transparent inline-flex mr-1 text-gray-500 hover:text-gray-700 hover:border-gray-300 whitespace-nowrap pb-4 px-1 border-b-2 font-medium text-sm"
                    label="View"
        ></pop-button>
    `
})
export class MessagingViewToggle implements OnInit{
    viewsMenu: IMenuItem[];
    key: string = 'conversationMode';

    constructor(
        private lSvc: LocalStorageService,
        private mSvc: MessagingService,
        private cSvc: ClientService
    ) {}

    ngOnInit(): void {
        this.mSvc.mode$.subscribe(() => {
            this.buildMenu();
        })
    }

    buildMenu() {
        const currentMode = this.lSvc.localState[this.cSvc.name_key]?.conversationMode || 'messages';
        this.viewsMenu = [
            {
                label: currentMode === 'threads' ? 'Threads View - ✓' : 'Threads View',
                click: async () => {
                    this.mSvc.updateMode('threads')
                    this.buildMenu();
                }
            },
            {
                label: currentMode === 'messages' ? 'Messages View - ✓' : 'Messages View',
                click: async () => {
                    this.mSvc.updateMode('messages');
                    this.buildMenu();
                }
            }
        ]
    }



}
